<template>
  

  <div class="layout-wrapper">
    <Header />
    <Sidebar />
    <div class="main-content">
      <div class="page-content">
          <div class="container-fluid">
            <router-view></router-view>
          </div>
      </div>
    </div>
    <Footer></Footer>
    <LayoutCustomizer
      :layout="layout"
      :topbar="topbar"
      :sidebar="sidebar"
      :sidebarSize="sidebarSize"
      :layoutWidth="layoutWidth"
      :layoutPosition="layoutPosition"
      @update-layout="layout = $event"
      @update-topbar="topbar = $event"
      @update-sidebar="sidebar = $event"
      @update-sidebar-size="sidebarSize = $event"
      @update-layout-width="layoutWidth = $event"
      @update-layout-position="layoutPosition = $event"
    />
  </div>


  <!-- <LoginView v-else /> -->


  
</template>


<script>
import Header from '@/components/Header.vue';
import Sidebar from '@/components/Sidebar.vue';
import Footer from '@/components/Footer.vue';
import LayoutCustomizer from '@/components/LayoutCustomizer.vue';

export default {
  components: {
    Header,
    Sidebar,
    Footer,
    LayoutCustomizer,
  },
  name: 'MainLayout',

  data() {
    return {
      layout: 'vertical',
      topbar: 'light',
      sidebar: 'dark',
      sidebarSize: 'lg',
      layoutWidth: 'fluid',
      layoutPosition: 'fixed'
    }
  },

  watch: {
    layout(val) {
      document.documentElement.setAttribute('data-layout', val)
    },
    topbar(val) {
      document.documentElement.setAttribute('data-topbar', val)
    },
    sidebar(val) {
      document.documentElement.setAttribute('data-sidebar', val)
    },
    sidebarSize(val) {
      document.documentElement.setAttribute('data-sidebar-size', val)
    },
    layoutWidth(val) {
      document.documentElement.setAttribute('data-layout-width', val)
    },
    layoutPosition(val) {
      document.documentElement.setAttribute('data-layout-position', val)
    }
  },

  mounted() {
    // Boshlang'ich qiymatlarni HTMLga qo‘llash
    document.documentElement.setAttribute('data-layout', this.layout)
    document.documentElement.setAttribute('data-topbar', this.topbar)
    document.documentElement.setAttribute('data-sidebar', this.sidebar)
    document.documentElement.setAttribute('data-sidebar-size', this.sidebarSize)
    document.documentElement.setAttribute('data-layout-width', this.layoutWidth)
    document.documentElement.setAttribute('data-layout-position', this.layoutPosition)
  }
}
</script>